export default __webpack_public_path__ + "1c421cc.png";